import { useQuery } from "@tanstack/react-query";
import { getTranslations, getLanguages, getconfiguration } from "../api/languageApi";

export const useTranslations = ({ language_code, appname }, options = {}) => {
  return useQuery({
    queryKey: ["GET_TRANSLATIONS", language_code, appname],
    queryFn: () => getTranslations({ language_code, appname }),
    ...options
  });
};

export const useLanguages = ( options = {}) => {
  return useQuery({
    queryKey: ["GET_LANGUAGES"],
    queryFn: () => getLanguages(),
    ...options
  });
};

export const useConfiguration = ( options = {}) => {
  return useQuery({
    queryKey: ["GET_CONFIGURATION"],
    queryFn: () => getconfiguration(),
    ...options
  });
};